<template>
  <div class="s1-U__pd16" v-if="applications && applications.length > 0">
    <div class="md-layout">
      <div
        class="md-layout-item"
        :class="mdSizeClasses || 'md-size-50'"
        v-for="application in (applications || [])"
        :key="application.Id"
      >
        <md-button
          class="s1-U__height-auto s1-U__pd--bt16 s1-U__full-width md-button-content--full-width"
          @click="redirectTo(application.Url)"
        >
          <div class="s1-U__full-height s1-U__full-width s1-U__mg--bt4 s1-U__pd16">
            <img :src="application.IconUri" alt>
          </div>
          <h6 class="s1-U__text-ellipsis">{{ application.Name }}</h6>
        </md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    mdSizeClasses: String
  },
  methods: {
    redirectTo(url) {
      window.open(url, "_blank");
    }
  },
  computed: {
    ...mapGetters('user', {
      applications: 'APPLICATIONS'
    })
  }
}
</script>
